/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Icon, FlexRow, FlexCol } from 'sarsaparilla';

export default function GovernmentShutdownNotification() {
    return (
        <FlexRow className="lottery-section-notification-wrap hidden">
            <FlexCol smOffset={1} sm={10} mdOffset={2} md={8}>
                <div className="rec-notification-warning">
                    <span className="rec-notification-icon">
                        <Icon iconName="warning" />
                    </span>
                    <div className="rec-notification-body">
                        <div className="rec-notification-title">
                            Federal Government Lapse in Funding:
                        </div>
                        <p>
                            Lotteries with current application periods are open for
                            submission during the lapse in funding for the Federal
                            government. Please refer to the specific location pages for
                            more information on individual lottery details.
                        </p>
                    </div>
                </div>
            </FlexCol>
        </FlexRow>
    );
}
